export default import.meta.ROLLUP_FILE_URL_dJ$ULFcuzX43djbIEsCZPw;